import React from "react";

type CursorType = {
    cursorCounter: number;
};

function getDefaultCursor(): CursorType {
    return {
        cursorCounter: 0,
    };
}

export const CursorContext = React.createContext<CursorType>(getDefaultCursor());

export const CursorActionsContext = React.createContext({
    showCursor: () => {
        // empty function
    },
    hideCursor: () => {
        // empty function
    },
});

export const useCursorContext = () => React.useContext(CursorContext);

export const useCursorActionsContext = () => React.useContext(CursorActionsContext);

type PropsType = {
    children: JSX.Element;
};

export const CursorContextProvider = (props: PropsType) => {
    const [cursor, SetCursor] = React.useState<CursorType>(getDefaultCursor());

    const showCursor = React.useCallback(() => {
        SetCursor((prevCursor: CursorType) => ({
            ...prevCursor,
            cursorCounter: prevCursor.cursorCounter + 1,
        }));
    }, []);

    const hideCursor = React.useCallback(() => {
        SetCursor((prevCursor: CursorType) => ({
            ...prevCursor,
            cursorCounter: prevCursor.cursorCounter - 1,
        }));
    }, []);

    React.useEffect(() => {
        if (cursor.cursorCounter > 0) {
            document.body.classList.add("busy");
            document.body.classList.remove("not-busy");
        } else {
            document.body.classList.remove("busy");
            document.body.classList.add("not-busy");
        }
    }, [cursor.cursorCounter]);

    const cursorActionsValue = React.useMemo(() => {
        return { showCursor, hideCursor };
    }, [showCursor, hideCursor]);

    return (
        <CursorContext.Provider value={cursor}>
            <CursorActionsContext.Provider value={cursorActionsValue}>
                {props.children}
            </CursorActionsContext.Provider>
        </CursorContext.Provider>
    );
};
